import Vue from "vue";
import Router from "vue-router";
import CompanyHome from "@/views/CompanyHome.vue";
import AlipayRealname from "@/views/AlipayRealname.vue";
import AlipayIdImageUpdate from "@/views/AlipayIdImageUpdate.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    { path: "/", component: CompanyHome },
    {
      path: "/UserInfo",
      name: "Alipay",
      component: AlipayRealname
    },
    {
      path: "/IdCard",
      name: "AlipayIdImageUpdate",
      component: AlipayIdImageUpdate
    },
    {
      path: '/:asin',
      name: 'CompanyHomeAsin',
      component: () => import('../views/CompanyHomeAsin.vue')
    }
  ],
});
